/**
 * AVG/GDPR-compliant Google Analytics 4 control via Google Consent Mode v2.
 *
 * The gtag.js script is always present in the document head (so Search Console
 * and tag verifiers can detect it), but is bootstrapped with consent defaults
 * set to "denied". No analytics_storage is allowed until the user clicks
 * "Accepteren" in the cookie banner — at which point we call
 * gtag('consent', 'update', { analytics_storage: 'granted' }).
 */
export const GA_ID = "G-GNM3GCRPHN";
export const CONSENT_KEY = "wasz_cookie_consent";

const gtagCall = (...args) => {
  if (typeof window === "undefined") return;
  // Initialise dataLayer if for any reason the inline bootstrap hasn't run yet.
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
  window.gtag(...args);
};

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* storage unavailable */
  }
};

export const grantAnalyticsConsent = () => {
  gtagCall("consent", "update", {
    analytics_storage: "granted",
  });
};

export const denyAnalyticsConsent = () => {
  gtagCall("consent", "update", {
    analytics_storage: "denied",
  });
};
